import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Table(theme: Theme) {
  return {
    MuiTableRow: {
      styleOverrides: {
        root: {
          transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest,
          }),
          // No divider under the last row of a table body
          '&:last-of-type > td': {
            borderBottom: 'none',
          },
          '&.MuiTableRow-hover:hover': {
            backgroundColor: theme.palette.action.hover,
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.action.selected,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: 'none',
          // Tighter cells on phones so more of each row fits on screen
          [theme.breakpoints.down('md')]: {
            padding: theme.spacing(1.25, 1.5),
          },
        },
        sizeSmall: {
          [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0.75, 1.25),
          },
        },
        paddingNone: {
          padding: 0,
        },
        paddingCheckbox: {
          [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0, 0.5),
          },
        },
        head: {
          color: theme.palette.text.secondary,
          fontWeight: theme.typography.fontWeightBold,
          fontSize: theme.typography.pxToRem(13),
          whiteSpace: 'nowrap',
          backgroundColor: theme.palette.background.neutral,
          '&:first-of-type': {
            paddingLeft: theme.spacing(2),
            [theme.breakpoints.up('md')]: {
              paddingLeft: theme.spacing(3),
            },
            borderTopLeftRadius: theme.shape.borderRadius,
            borderBottomLeftRadius: theme.shape.borderRadius,
            boxShadow: `inset 8px 0 0 ${theme.palette.background.paper}`,
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(2),
            [theme.breakpoints.up('md')]: {
              paddingRight: theme.spacing(3),
            },
            borderTopRightRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius,
            boxShadow: `inset -8px 0 0 ${theme.palette.background.paper}`,
          },
        },
        stickyHeader: {
          backgroundColor: theme.palette.background.paper,
          backgroundImage: `linear-gradient(to bottom, ${theme.palette.background.neutral} 0%, ${theme.palette.background.neutral} 100%)`,
        },
        body: {
          borderBottom: `1px dashed ${theme.palette.divider}`,
          '&:first-of-type': {
            paddingLeft: theme.spacing(2),
            [theme.breakpoints.up('md')]: {
              paddingLeft: theme.spacing(3),
            },
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(2),
            [theme.breakpoints.up('md')]: {
              paddingRight: theme.spacing(3),
            },
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: `solid 1px ${theme.palette.divider}`,
        },
        toolbar: {
          height: 64,
          // On phones the pagination controls wrap instead of overflowing the card
          [theme.breakpoints.down('sm')]: {
            height: 'auto',
            minHeight: 56,
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
            rowGap: theme.spacing(0.5),
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            paddingLeft: theme.spacing(1.5),
            paddingRight: theme.spacing(1),
          },
        },
        spacer: {
          [theme.breakpoints.down('sm')]: {
            display: 'none',
          },
        },
        input: {
          [theme.breakpoints.down('sm')]: {
            marginRight: theme.spacing(1.5),
          },
        },
        actions: {
          [theme.breakpoints.down('sm')]: {
            marginLeft: theme.spacing(1),
          },
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
        selectIcon: {
          width: 20,
          height: 20,
          marginTop: -4,
        },
      },
    },
  };
}
